import {initMixpanel} from 'common/report/tracking-setup';

export enum TrackingEvent {
  OpenedMenu = `[Metric Units] Opened menu`,
  Reset = `[Metric Units] Reset`,
  SelectedPreset = `[Metric Units] Selected preset`,
  UpdatedUnits = `[Metric Units] Updated units`,
}

export enum CallingLocation {
  Metric = `metric`,
  Axis = `axis`,
}

let mixpanel: any | null;

export function track(event: TrackingEvent, callingLocation: CallingLocation, data: Record<string, any> = {}) {
  // Don't initialize mixpanel immediately on import so we don't break tests
  if (!mixpanel) {
    mixpanel = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);
  }
  mixpanel.track(event, {...data, callingLocation});
}
